// Cache the selectors to avoid querying the DOM multiple times
const navbarHeader = document.querySelector('nav.navbar-header');
const navbarHeaderLink = document.createElement('div');
navbarHeaderLink.className = 'd-flex navbar-header-link';
navbarHeader.appendChild(navbarHeaderLink);

// Move the element with class 'nav-main-search-trigger' to the newly created div
const searchTrigger = document.querySelector('.navbar-main-header .nav-main-search-trigger');
navbarHeaderLink.appendChild(searchTrigger);

// Move the element with class 'component logo' to the beginning of 'nav.navbar-header'
const logo = document.querySelector('.navbar-main-header .component.logo');
navbarHeader.insertBefore(logo, navbarHeader.firstChild);

// Move the element with class 'nav-main-list-trigger' to 'nav-main-bar'
//const listTrigger = document.querySelector('.navbar-main-header .nav-main-list-trigger');
//document.querySelector('nav-main-bar').appendChild(listTrigger);

// Move the element with id 'nav-main-mobile' after 'nav.navbar-header'
const navMainMobile = document.getElementById('nav-main-mobile');
navbarHeader.parentNode.insertBefore(navMainMobile, navbarHeader.nextSibling);
navbarHeader.style.display = '';